// extracted by mini-css-extract-plugin
module.exports = {"icon-seletion-wrapper":"content-sorter_icon-seletion-wrapper__1EgFq"};